const SettingsDRCheckpointsChartConfigurationPage = () => import('frontend/pages/settings/DRCheckpoints/SettingsDRCheckpointsChartConfigurationPage')
const SettingsTimeTrackingCategoryPage = () => import('frontend/pages/settings/SettingsTimeTrackingCategoryPage')
const SettingsPreviousCommentsTime = () => import('frontend/pages/settings/SettingsPreviousCommentsTime')

import { CONFIGURATION_KEYS } from 'frontcore/constants/constants'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: SETTINGS_CARDS_TOKENS.drCheckpointsTimeTrackingCategory.name,
    name: SETTINGS_CARDS_TOKENS.drCheckpointsTimeTrackingCategory.name,
    components: {
      default: SettingsTimeTrackingCategoryPage,
    },
  },
  {
    path: SETTINGS_CARDS_TOKENS.drPreviousCommentsTime.name,
    name: SETTINGS_CARDS_TOKENS.drPreviousCommentsTime.name,
    components: {
      default: SettingsPreviousCommentsTime,
    },
    props: {
      default: { configurationKeyName: CONFIGURATION_KEYS.DR_ACTIVITIES_PREVIOUS_COMMENTS_TIME_CONFIG },
    },
  },
  {
    path: SETTINGS_CARDS_TOKENS.drChartConfiguration.name,
    name: SETTINGS_CARDS_TOKENS.drChartConfiguration.name,
    components: {
      default: SettingsDRCheckpointsChartConfigurationPage,
    },
  },
]
